









import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { storeModuleName as UiStore } from '@/store/modules/ui'
import UiButton from '@/components/ui/UiButton.vue'

interface Data {}

interface Methods {
  onClick: (e: any) => void
  setConsultationModalStatus: (value: boolean) => void
}

interface Computed {}

interface Props {
  title: string
  highlightedWord: string
}

export default Vue.extend({
  name: 'ConsultationBanner',
  components: {
    UiButton
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    highlightedWord: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    onClick (e: any) {
      this.setConsultationModalStatus(true)
    },
    ...mapMutations(UiStore, ['setConsultationModalStatus'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
